import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserServiceProvider } from "../user-service/user-service";

@Injectable()
export class ApiServiceProvider {
  // TEST SERVER
  // DONOT TOUCH
  // private host = "http://171.244.40.209";
  // private port = 5000;

  // private host = "http://171.244.39.202";
  // private port = 5000;

  // private host = "http://171.244.139.59";
  // private port = 5000;

  private host = "https://zoobeweb.ciibos.com";
  private port = 5000;

  // private host = "http://localhost";
  // private port = 5000;

  public api = {
    login: "login",
    auth: "Authentication",
    user_get_password: "gencb/UserGetPassword",
    user_change_password: "gencb/UserChangePassword"
  };

  constructor(public http: HttpClient) { }

  /**
   * Get full api URI
   *
   * @param api_name Api name in array
   * @param params Param pass to uri
   */
  getFullUri(api_name: string, params?: any) {
    let uri = this.host + ":" + this.port + "/" + api_name;

    if (typeof params != "undefined") {
      let array = [];
      for (let prop in params) {
        array.push(prop + "=" + params[prop]);
      }

      uri += "?" + array.join("&");
    }

    return uri;
  }

  /**
   * Do a GET request to API
   *
   * @param api_name
   * @param params
   */
  get(api_name: string, params?: any) {
    let api_uri = this.getFullUri(api_name, params);

    return new Promise(resolve => {
      //alert("Last request URL to server" + api_uri);
      this.http.get(api_uri).subscribe(
        data => {
          resolve(data);
        },
        err => {
          console.log(err);
          alert(
            "Có lỗi mất kết nối đến máy chủ. Kiểm tra đường truyền" +
            JSON.stringify(err.message)
          );
          resolve({ info: "NOT_OK", returnData: null });
        }
      );
    });
  }

  /**
   * Do a POST request to API
   *
   * @param api_name
   * @param params
   * @param url_param
   */
  post(
    api_name: string,
    params?: any,
    url_param?: boolean,
    parse_json?: boolean
  ) {
    let api_uri = "";

    if (url_param) {
      api_uri = this.getFullUri(api_name, params);
    } else {
      api_uri = this.getFullUri(api_name);
    }

    if (params == null) {
      params = {};
    }
    if (parse_json) params = JSON.stringify(params);
    let options = {
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("token")
      }
    };

    return new Promise(resolve => {
      //alert("Last request URL to server" + api_uri);
      this.http.post(api_uri, params, options).subscribe(
        data => {
          resolve(data);
        },
        err => {
          console.log(err);
          alert(
            "Có lỗi mất kết nối đến máy chủ. Kiểm tra đường truyền" +
            JSON.stringify(err.message)
          );
          resolve({ info: "NOT_OK", returnData: null });
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/api-service/api-service.ts